module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1032.3f62b5bb.png";